import '../Modal/modal.css';
import React from 'react';

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        top: `-200px`,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(0, 0, 0, .7) ',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          background: 'white',
          height: 130,
          width: 380,
          margin: 'auto',
          padding: '1.5%',
          border: '3px solid #ef6023',
          borderRadius: '10px',
          boxShadow: '4px solid black',
          textAlign: `center`,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;
